import { render } from "./SavesCard.vue?vue&type=template&id=77e25009&scoped=true&bindings={}"
import script from "./SavesCard.vue?vue&type=script&lang=ts"
export * from "./SavesCard.vue?vue&type=script&lang=ts"

import "./SavesCard.vue?vue&type=style&index=0&id=77e25009&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-77e25009"

export default script